import React, { type ChangeEvent } from "react"
import { useTranslation } from "react-i18next"
import styles from "./text-card-wrapper-with-icon.module.css"
import AinIcon from "@/assets/icons/farm/ain-icon.tsx"
import OverflowMenuItem from "@/components/task-card/overflow-menu-item.tsx"
import RequiredIndicator from "@/features/farm/components/required-indicator/required-indicator.tsx"
import { InputType } from "@/utils/enums/input-type-enum.ts"

interface TextCardProps {
  isDisabled: boolean
  isRequired?: boolean
  value: any
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

const AinInputField: React.FC<TextCardProps> = ({
  isDisabled,
  value = "",
  onChange,
  isRequired = false,
}) => {
  const { t } = useTranslation()
  const name = t("crotal")

  return (
    <OverflowMenuItem isDisabled={isDisabled}>
      <div
        className={styles.textCardIconWrapper}
        style={{ flexDirection: "row" }}
      >
        <div className={styles.icon}>
          <AinIcon />
        </div>
        <div className={"flex items-center justify-center gap-1.5"}>
          <div className={"text-[14px]"}>RO</div>
          <input
            name={name}
            alt={name}
            maxLength={14}
            inputMode={"numeric"}
            className={`${styles.textInput} ${isDisabled ? styles.inputDisabled : ""}`}
            type={InputType.TEXT}
            placeholder={name}
            value={value}
            onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event)}
            readOnly={isDisabled}
          />
        </div>
      </div>
      {isRequired && <RequiredIndicator />}
    </OverflowMenuItem>
  )
}

export default AinInputField
